import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardImg, CardText, CardBody, CardTitle, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import CommentForm from './CommentFormComponent';
import { Loading } from './LoadingComponent';
import { FadeTransform, Stagger, Fade } from 'react-animation-components';
import { baseUrl } from '../shared/baseUrl';

function RenderDish({ selectedDish }) { //using object destructuring on props
    return (
        <FadeTransform in transformProps={{
            exitTransform: 'scale(0.5) TranslateY(-50%)'
        }}>
            <Card id={selectedDish.id}>
                <CardImg width="100%" src={`${baseUrl}${selectedDish.image}`} alt={selectedDish.name} />
                <CardBody>
                    <CardTitle>{selectedDish.name}</CardTitle>
                    <CardText>{selectedDish.description}</CardText>
                </CardBody>
            </Card>
            {
                useEffect(() => {
                    window.scrollTo({
                        behavior: 'smooth',
                        top: document.getElementById(selectedDish.id).offsetWidth
                    });
                })
            }
        </FadeTransform>
    )
}

const RenderComments = ({ comments, commentsErrMessage, dishId, postComment }) => {
    if (commentsErrMessage) {
        return (
            <h4>{commentsErrMessage}</h4>
        );
    }
    return comments ?
        <div>
            <h4>Comments</h4>
            <ul className="list-unstyled">
                <Stagger in>
                    {comments.map(comment => {
                        return (
                            <Fade in>
                                <div key={comment.id}>
                                    <li>{comment.comment}</li>
                                    <br />
                                    <li>-- {comment.author}, {new Date(comment.date).toLocaleDateString('en-US',
                                        { timeZone: "UTC", month: "short", day: "2-digit", year: "numeric" })}</li>
                                    <br />
                                </div>
                            </Fade>
                        )
                    })}
                </Stagger>
            </ul>
            <CommentForm dishId={dishId} postComment={postComment} />
        </div>
        : <div></div>
}

export const DishDetail = (props) => {
    const selectedDish = props.selectedDish;
    const dishLoading = props.dishLoading;
    const dishErrMessage = props.dishErrMessage;
    const comments = props.comments;
    const commentsErrMessage = props.commentsErrMessage;
    if (dishLoading) {
        return (
            <Loading />
        );
    }
    else if (dishErrMessage) {
        return (
            <h4 className="text-center">{dishErrMessage}</h4>
        );
    }
    else if (selectedDish != null) {
        return (
            <div className="container">
                <div className="row">
                    <Breadcrumb className="breadcrumb-dark">
                        <BreadcrumbItem>
                            <Link to={"/menu"}>Menu</Link>
                        </BreadcrumbItem>
                        <BreadcrumbItem className="active">
                            <Link to={`/menu/${selectedDish.id}`}>{selectedDish.name}</Link>
                        </BreadcrumbItem>
                    </Breadcrumb>
                    <div className="col-12">
                        <h3>{selectedDish.name}</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-md-5 mt-1 mb-2">
                        <RenderDish selectedDish={selectedDish} />
                    </div>
                    <div className="col-12 col-md-5 mt-1 mb-5">
                        <RenderComments comments={comments} commentsErrMessage={commentsErrMessage}
                            postComment={props.postComment} dishId={props.selectedDish.id} />
                    </div>
                </div>
            </div>
        )
    }
}

export default DishDetail;